import React from "react";
import Header from "./../Common/Header";
import Footer from "./../Common/Footer";
import Banner from "./../Elements/Banner";
import AboutCompany from "../Elements/AboutCompany";
import OurServices3 from "../Elements/OurServices3";

var bnrimg = require("./../../images/banner/1.png");

class Services extends React.Component {
  render() {
    return (
      <>
        <Header />
        <div className="page-content">
          <Banner
            title="Multiple services. One standard of excellence."
            pagename="Services"
            bgimage={bnrimg}
          />
          <AboutCompany />
          <OurServices3 />
        </div>
        <Footer />
      </>
    );
  }
}

export default Services;
